/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-syntax */
export class Trie {
  /** 这个节点下面，有几个直接或间接 value */
  get size() {
    return this._size;
  }
  constructor(absolutePath) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    this._size = 0;
    this.absolutePath = absolutePath || [];
    this.key = this.absolutePath[this.absolutePath.length - 1];
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  _internalAddValue(path, value, pathIdx) {
    this._size += 1;
    // 这里就是落地点，添加到现在这个节点
    if (pathIdx >= path.length) {
      if (!this.values) this.values = [value];else this.values.push(value);
      return;
    }
    const k = path[pathIdx];
    if (!this.children) this.children = Object.create(null);
    let next = this.children[k];
    // eslint-disable-next-line no-multi-assign
    if (!next) next = this.children[k] = new Trie([...this.absolutePath, k]);
    // eslint-disable-next-line no-underscore-dangle
    next._internalAddValue(path, value, pathIdx + 1);
  }
  add(path, value) {
    this._internalAddValue(path, value, 0);
  }
  *[Symbol.iterator]() {
    const pendingNodes = [this];
    while (pendingNodes.length) {
      const node = pendingNodes.shift();
      if (node.values) {
        for (const value of node.values) {
          yield {
            value,
            path: node.absolutePath.slice(),
            node
          };
        }
      }
      if (node.children) {
        Object.keys(node.children).forEach(childKey => {
          const childNode = node.children[childKey];
          pendingNodes.push(childNode);
        });
      }
    }
  }
  /**
   * 获取当前 Trie 的某个子节点，如果节点不存在，返回 undefined
   *
   * @param path 相对于这个节点的 相对 path
   */
  getChildNode(path) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let ptr = this;
    for (let i = 0; i < path.length; i++) {
      var _ptr$children;
      if (!ptr) return;
      const key = path[i];
      ptr = (_ptr$children = ptr.children) === null || _ptr$children === void 0 ? void 0 : _ptr$children[key];
    }
    return ptr;
  }
  forEach(callback) {
    for (const item of this) callback(item.value, item.path, item.node);
  }
}
//# sourceMappingURL=Trie.js.map
